import { FC } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface CalendarNavigationButtonProps {
  direction: 'prev' | 'next';
  onClick: () => void;
}

export const CalendarNavigationButton: FC<CalendarNavigationButtonProps> = ({
  direction,
  onClick,
}) => {
  const Icon = direction === 'prev' ? ChevronLeft : ChevronRight;
  const label = direction === 'prev' ? 'Previous month' : 'Next month';

  return (
    <button
      type="button"
      onClick={onClick}
      className="p-2 hover:bg-(--neutral-black-NB100) rounded-lg! transition-all cursor-pointer"
      aria-label={label}
    >
      <Icon className="w-5 h-5 lg:w-6 lg:h-6 text-(--neutral-black-NB600)" strokeWidth={2} />
    </button>
  );
};
